import { useQuery } from "@tanstack/react-query";
import api from "../../services/api";

export const useViewSingleApplicationImage = (id) => {
  return useQuery({
    queryKey: ["applicationImage", id],
    queryFn: async () => {
      const res = await api.get(`/application-image/${id}`);
      return res.data;
    },
    enabled: !!id, // prevents unnecessary call
  });
};